<template>
  <div class="main">
    <h2 class="conTitle">标签</h2>
    <ul class="tagItem clearfix">
      <li @click="$goRoute('noteList',{noteListData:item})" v-for="item in tagsData">{{item.tagType}}<span>({{item.tagData.length}})</span>
      </li>
    </ul>
  </div>
</template>

<script>
  export default {
    name: 'tags',
    data() {
      return {
        title: '标签'
      }
    },
    components: {},
    computed: {
      tagsData: function () {
        let obj = {}, tagCurData = this.$store.state.noteList.notes || [];
        // console.log(222, tagCurData);

        for (let i = 0; i < tagCurData.length; i++) {
          // console.log(this.tagCurData[i]);
          if (obj[tagCurData[i].type]) {
            obj[tagCurData[i].type].tagData.push(tagCurData[i])
          } else {
            obj[tagCurData[i].type] = {
              tagType: tagCurData[i].type,
              tagData: [tagCurData[i]]
            }
          }
        }

        return obj
      }
    },
    mounted: function () {
      window.document.title='标签 - 小桃酥的曲奇饼';
    }
  }
</script>
<style lang="scss">
  .main {

    .conTitle {
      font-size: 32px;
      margin-bottom: 25px;
      font-weight: 300;
    }
    .tagItem {
      li {
        float: left;
        height: 40px;
        line-height: 40px;
        border: 1px solid #2479CC;
        border-radius: 4px;
        padding: 0 15px;
        margin: 0 15px 10px 0;
        font-size: 14px;
        color: #2479CC;
        cursor: pointer;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/tags.vue